import { Box, useTheme } from '@chakra-ui/react';

const FooterLink = ({ dataTestId, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      as='a'
      color={theme.colors.mediumGrey3}
      textDecoration='none'
      _hover={{
        textDecoration: 'underline',
        color: theme.colors.blue
      }}
      data-testid={dataTestId}
      {...props}
    />
  );
};

export default FooterLink;
